export const openOfficial2307Pdf = (report, popup) => {
  const binary = window.atob(report.pdfBase64);
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) bytes[index] = binary.charCodeAt(index);
  const url = URL.createObjectURL(new Blob([bytes], { type: "application/pdf" }));
  popup.location.replace(url);
  window.setTimeout(() => URL.revokeObjectURL(url), 300000);
};
